import { useState , useEffect,useRef} from "react";
import axiosInstance from "../services/axiosInstance";
import { FaInfoCircle } from "react-icons/fa";
import Loader from "../components/Loader";
import AttendanceLog from "../pages/AttendanceLog";

export default function Employees() {
  const [loading, setLoading] = useState(false);
 const [employees,setEmployees] = useState([]);
 const today = new Date();

  const [nameSearch, setNameSearch] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [subjectFilter, setSubjectFilter] = useState("");
  const [selectedEmploye, setSelectedEmploye] = useState(null);
  const [attendanceEmployee, setAttendanceEmployee] = useState(null);
  // const [attendanceStatus, setAttendanceStatus] = useState("PRESENT");
  // const [attendanceDate, setAttendanceDate] = useState(new Date().toISOString().split("T")[0]);
  // const [remarks, setRemarks] = useState("");

  const hasFetched = useRef(false);
  const openAttendanceModal = (employee) => {setAttendanceEmployee(employee);};
   useEffect(() => {
     if (hasFetched.current) return;
      hasFetched.current = true;
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/employees/retrieve");
      setEmployees(response.data);
    } catch (err) {
      alert("Failed to load Staff,Please retry");
    } finally {
      setLoading(false);
    }
  };
    // Unique dropdown values
// const uniqueClasses = employees ? [...new Set(employees.map(t => t.className))] : [];

  const uniqueSubjects = employees ? [...new Set(employees.map(t => t.subjects))] : [];

  const uniqueDepartments = employees ? [...new Set(employees.map(t => t.department))] : [];
 
  // Filtering logic
  const filteredEmployees =  employees ? employees.filter((employe) => {
    const name = employe.employeeName || "";
    const department = employe.department || "";
    const subject = employe.subjects || "";
    const matchesName =
      name.toLowerCase().includes(nameSearch.toLowerCase());

    const matchesDepartment =
      departmentFilter === "" || department === departmentFilter;

    const matchesSubject =
      subjectFilter === "" || subject === subjectFilter;

    return matchesName && matchesDepartment && matchesSubject;
  }): [];

  const saveEmployee = async () => {//Save Logic
        try {
          setLoading(true);
          const response = await axiosInstance.post("/employees/save", selectedEmploye);
          if (response.data.status === "SUCCESS") {
            alert("Employee Saved successfully");
            setSelectedEmploye(null)
           // setStudentSaved(true);
            fetchStaff();
          } else {
            if (response.data.errors && response.data.errors.length > 0) {
              alert(response.data.errors.join("\n")); // show all errors
            } else {
              alert(response.message || "Error in Saving Employee");
            }
          }
        } catch (errors) {
            alert("Error in Saving Wmployee");
        }finally{
          setLoading(false);
        }

      };

  return (
    <div>

      {/* Header Section */}
     <div className="flex justify-between items-center mb-6">
        {loading && <Loader />}
        <h2 className="text-2xl font-bold">Staff</h2>

        <div className="flex gap-3">

          {/* Refresh Button */}
          <button
            //onClick={fetchUsers}
            className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded flex items-center gap-2"
          >
            🔄 Refresh
          </button>

          {/* New Employee Button */}
          <button
            onClick={() => {
              setSelectedEmploye({
                employeeName: "",
                employeeCode: "EMP",
                phone: "",
                email: "",
                gender: "Male",
                isActive: true,
                altPhone: "",
                designation: "",
                department: "",
                bloodGroup:"",
                salary:"",
                address:"",
                qualification:"",
                joinDate:today,
                leaveDate:""
              });
             // setShowModal(true);
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            + New
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="flex flex-col md:flex-row gap-4 mb-6">

        {/* Name Search */}
        <input
          type="text"
          placeholder="Search by name..."
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={nameSearch}
          onChange={(e) => setNameSearch(e.target.value)}
        />

        {/* Department Filter */}
        <select
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={departmentFilter}
          onChange={(e) => setDepartmentFilter(e.target.value)}
        >
          <option value="">All Departments</option>
          {uniqueDepartments.map((dep, index) => (
            <option key={index} value={dep}>
              {dep}
            </option>
          ))}
        </select>

        {/* Subject Filter */}
        <select
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={subjectFilter}
          onChange={(e) => setSubjectFilter(e.target.value)}
        >
          <option value="">All Subjects</option>
          {uniqueSubjects.map((sub, index) => (
            <option key={index} value={sub}>
              {sub}
            </option>
          ))}
        </select>

      </div>

      {/* Table */}
      <div className="bg-white shadow rounded-xl overflow-x-auto">
        <table className="w-full text-left">
          <thead className="bg-gray-100 text-gray-600">
            <tr>
              <th className="p-4">Emp ID</th>
              <th className="p-4">Name</th>
              <th className="p-4">Email</th>
              <th className="p-4">Subjects</th>
              <th className="p-4">Attendance</th>
            </tr>
          </thead>

          <tbody>
            {filteredEmployees.length > 0 ? (
              filteredEmployees.map((employe) => (
                <tr
                  key={employe.id}
                  className="border-t hover:bg-gray-50 transition"
                >
                 <td className="p-4">
                    <div className="flex items-center gap-2">
                       {/* Info icon */}{employe.employeeCode}
                        <button onClick={() => setSelectedEmploye(employe)} className="text-gray-500 hover:text-blue-600"  >
                        <FaInfoCircle size={14} />
                        </button>
                    </div>
                </td>
                  <td className="p-4">{employe.employeeName}</td>
                  <td className="p-4">{employe.email}</td>
                  <td className="p-4">{employe.subjects}</td>
                  <td className="p-4">
                    <button
                      onClick={() => openAttendanceModal(employe)}
                      className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700"
                    >
                      Attendance
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center p-6 text-gray-500">
                  No employees found
                </td>
              </tr>
            )}
          </tbody>

        </table>
        {selectedEmploye && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4 z-50">
                {loading && <Loader />}
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl p-6 relative">

              {/* Close Button */}
              <button
                onClick={() => setSelectedEmploye(null)}
                className="absolute top-4 right-4 text-gray-500 hover:text-black"
              >
                ✕
              </button>

              {/* Title */}
              <h2 className="text-2xl font-bold mb-6">
                Employee Details
              </h2>

              {/* Grid Form */}
              <div className="grid grid-cols-3 gap-4 text-sm">

                <div>
                  <label className="font-semibold">Employee Code</label>
                  <input
                    value={selectedEmploye.employeeCode || ""}
                    disabled
                    className="w-full border rounded p-2 bg-gray-100"
                  />
                </div>

                <div>
                  <label className="font-semibold">Employee Name</label>
                  <input
                    value={selectedEmploye.employeeName || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        employeeName: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Email</label>
                  <input
                    value={selectedEmploye.email || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        email: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Phone</label>
                  <input
                    value={selectedEmploye.phone || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        phone: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Alt Phone</label>
                  <input
                    value={selectedEmploye.altPhone || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        altPhone: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Department</label>
                  <input
                    value={selectedEmploye.department || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        department: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Designation</label>
                  <input
                    value={selectedEmploye.designation || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        designation: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Subjects</label>
                  <input
                    value={selectedEmploye.subjects || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        subjects: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Join Date</label>
                  <input
                    type="date"
                    value={selectedEmploye.joinDate || ""}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        joinDate: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Salary</label>
                  <input
                    value={selectedEmploye.salary || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        salary: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Blood Group</label>
                  <input
                    value={selectedEmploye.bloodGroup || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        bloodGroup: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Qualification</label>
                  <input
                    value={selectedEmploye.qualification || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        qualification: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

                <div>
                  <label className="font-semibold">Employee Type</label>
                  <select
                    value={selectedEmploye.employeeType || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        employeeType: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  >
                    <option value="">Select</option>
                    <option value="FULL_TIME">Full Time</option>
                    <option value="PART_TIME">Part Time</option>
                    <option value="CONTRACT">Contract</option>
                  </select>
                </div>

                <div className="col-span-2">
                  <label className="font-semibold">Address</label>
                  <textarea
                    value={selectedEmploye.address || ""}
                    onChange={(e) =>
                      setSelectedEmploye({
                        ...selectedEmploye,
                        address: e.target.value
                      })
                    }
                    className="w-full border rounded p-2"
                  />
                </div>

              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3 mt-6">

                <button
                  onClick={() => setSelectedEmploye(null)}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancel
                </button>

                <button
                  onClick={() => saveEmployee(selectedEmploye)}
                  className="px-4 py-2 bg-blue-600 text-white rounded"
                >
                  Save
                </button>

              </div>

            </div>
          </div>
        )}
        

        {attendanceEmployee && (

          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

            {/* Modal Box */}
            <div className="relative bg-white rounded-xl shadow-xl w-[95%] max-w-5xl max-h-[90vh] overflow-y-auto p-6">

              {/* Close Button */}
              <button
                onClick={() => setAttendanceEmployee(null)}
                className="absolute top-4 right-4 text-gray-500 hover:text-black text-lg"
              >
                ✕
              </button>

              {/* Title */}
              <h2 className="text-xl font-semibold mb-6 border-b pb-2">
                Attendance Log - {attendanceEmployee.employeeName}
              </h2>

              {/* Attendance Component */}
              <AttendanceLog staffData={attendanceEmployee} />

            </div>

          </div>

        )}
      </div>

    </div>
  );
}